import meta from "@/data/logoPieces.json";

// Official SOLIDOR mark. Rendered via CSS mask so it inherits any color
// without altering the original geometry. Source assets: /public/logo/.
export const SolidorLogo = ({ className = "", color = "currentColor" }) => (
  <span
    data-testid="solidor-logo-mark"
    role="img"
    aria-label="SOLIDOR"
    className={className}
    style={{
      display: "inline-block",
      aspectRatio: `${meta.mark.w} / ${meta.mark.h}`,
      backgroundColor: color,
      WebkitMaskImage: `url(${meta.mark.src})`,
      maskImage: `url(${meta.mark.src})`,
      WebkitMaskSize: "contain",
      maskSize: "contain",
      WebkitMaskRepeat: "no-repeat",
      maskRepeat: "no-repeat",
      WebkitMaskPosition: "center",
      maskPosition: "center",
    }}
  />
);
